/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type { AssetPartsResponse } from '../models';

export type getAssetPartsResponse200 = {
    data: AssetPartsResponse;
    status: 200;
};

export type getAssetPartsResponse400 = {
    data: void;
    status: 400;
};

export type getAssetPartsResponse500 = {
    data: void;
    status: 500;
};

export type getAssetPartsResponseSuccess = getAssetPartsResponse200 & {
    headers: Headers;
};

export type getAssetPartsResponseError = (getAssetPartsResponse400 | getAssetPartsResponse500) & {
    headers: Headers;
};

export type getAssetPartsResponse = getAssetPartsResponseSuccess | getAssetPartsResponseError;

export const getGetAssetPartsUrl = (assetId: string) => `/api/v1/assets/${assetId}/parts`;

export const getAssetParts = async (
    assetId: string,
    options?: RequestInit
): Promise<getAssetPartsResponse> => {
    const res = await fetch(getGetAssetPartsUrl(assetId), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getAssetPartsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getAssetPartsResponse;
};
